module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_right.96d57213.svg";